import { TestTube } from 'lucide-react'
import { MockSidebar } from './mock-sidebar'
import { MockDashboard } from './mock-dashboard'
import type { Integration } from '@/types/integration'

/**
 * Mock Integration for Testing
 * 
 * This is a test integration to verify the integration framework works correctly.
 * It demonstrates:
 * - Sidebar panel rendering
 * - Main panel view rendering
 * - Dynamic tab creation
 * - Integration-specific UI
 * 
 * To enable: Uncomment in config/integrations.ts
 */
export const mockIntegration: Integration = {
  id: 'mock',
  name: 'Mock Integration',
  shortName: 'Mock',
  icon: TestTube,
  enabled: true,
  configured: true,
  SidebarView: MockSidebar,
  MainView: MockDashboard,
  color: 'purple',
  description: 'Test integration for framework validation',
}

